import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function OutstandingTasksCard({ className = "" }) {
  const { t } = useTranslation();

  return (
    <section
      className={[
        "w-full rounded-2xl bg-card px-2 py-3 shadow flex flex-col gap-2 text-left",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {/* The icon leads the heading rather than the whole text column, so the
          body runs full width and no gap opens up under the glyph. */}
      <div className="flex items-center gap-3">
        <span
          className="material-symbols-outlined text-[22px] leading-none text-primary"
          aria-hidden="true"
        >
          checklist
        </span>

        <p className="min-w-0 flex-1 font-semibold text-typography">
          {t("result.todoPrompt.title", "You have tasks left to complete")}
        </p>
      </div>

      <p className="muted-text text-sm">
        {t(
          "result.todoPrompt.body",
          "Open your To do list to see what still needs completing.",
        )}
      </p>

      {/* Matches the "Tips" CTA on ResultQualityNotice — while a result is
          still processing this is a quiet secondary prompt, not an action to
          push the user towards. */}
      <Link
        to="/todo"
        className="self-end inline-flex items-center gap-0.5 text-sm font-medium text-primary"
      >
        {t("result.todoPrompt.cta", "To Do List")}
        <span
          className="material-symbols-outlined text-[18px] leading-none"
          aria-hidden="true"
        >
          chevron_right
        </span>
      </Link>
    </section>
  );
}

export default memo(OutstandingTasksCard);
